<template>
  <span
    v-tooltip="active ? tooltip : undefined"
    class="translate-y-0-25 transform"
    :data-cy="containerDataCy"
    @click.prevent.stop="emit('click')"
  >
    <icon-base
      :data-cy="iconDataCy"
      :icon="IconSortDirection"
      :class="[
        active ? 'text-blue-500' : 'text-gray-400',
        { 'rotate-180 transform': rotate },
      ]"
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import IconSortDirection from "@/components/icons/IconSortDirection.vue";

const {
  name,
  sortBy = [],
  containerDataCy,
  iconDataCy,
} = defineProps<{
  name: string;
  sortBy?: readonly string[];
  containerDataCy: string;
  iconDataCy: string;
}>();

const emit = defineEmits<{
  click: [];
}>();

const { t } = useI18n();

const active = computed(() =>
  sortBy.some((entry) => entry === name || entry === `-${name}`)
);

const rotate = computed(() => {
  const entry = sortBy.find((e) => e === name || e === `-${name}`);
  return !!entry?.startsWith("-");
});

const tooltip = computed(() =>
  rotate.value
    ? t("SMART_FILTERS.SORTING_DESCENDING")
    : t("SMART_FILTERS.SORTING_ASCENDING")
);
</script>
